module.exports = __webpack_public_path__ + "static/media/icon-warning.e3ef32a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Others/icon-warning.svg
// module id = 1827
// module chunks = 0